import React from "react";
import { muv } from "./data/muv";
// import VehicleCard from "./VehicleCard";
import VehicleFullCard from "./VehicleFullCard";

export default function Muv() {
  return (

<>
<div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  MUV Cars
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>




<div className="vehicle-page">
  <div className="vehicle-container">
    {muv.map((v) => (
      <VehicleFullCard key={v.id} v={v} />
    ))}
  </div>
</div>

</>
  );
}
